<template>
  <Teleport to="body">
    <div v-if="state.open" class="scope" role="dialog" aria-modal="true" :aria-label="t(`calendar.scope.${state.action}.title`)" @keydown.esc="answer(null)">
      <div class="scope__panel">
        <h2 class="scope__title">{{ t(`calendar.scope.${state.action}.title`) }}</h2>
        <div class="scope__options">
          <button ref="first" type="button" class="scope__option" @click="answer('this')">{{ t('calendar.scope.this') }}</button>
          <button v-if="state.following" type="button" class="scope__option" @click="answer('following')">{{ t('calendar.scope.following') }}</button>
          <button type="button" class="scope__option" @click="answer('all')">{{ t('calendar.scope.all') }}</button>
        </div>
        <UiButton variant="ghost" block @click="answer(null)">{{ t('calendar.cancel') }}</UiButton>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { UiButton } from '@general/ui-kit'

import { useScopeChoice } from '../scope'

/**
 * Its own layer, above the editor's modal: a question asked from inside a
 * UiModal with another UiModal is drawn BEHIND it (same z-index), and the
 * screen waits for an answer nobody can see.
 */
const { t } = useI18n()
const { state, answer } = useScopeChoice()
const first = ref(null)
watch(() => state.open, async (open) => { if (open) { await nextTick(); first.value?.focus() } })
</script>

<style scoped>
/* Lo que se ve y no la ventana (ui-kit utils/viewport.js). */
.scope { position: fixed; inset: 0; top: var(--viewport-top, 0px); bottom: auto; height: var(--app-height, 100dvh); z-index: 188; background: rgba(15, 23, 42, .45); display: flex; align-items: center; justify-content: center; padding: var(--space-4); }
.scope__panel { background: var(--color-surface); border-radius: var(--radius-xl); box-shadow: var(--shadow-lg); padding: var(--space-5); width: min(380px, 100%); display: flex; flex-direction: column; gap: var(--space-3); }
.scope__title { font-size: var(--text-lg); font-weight: 600; margin: 0; }
.scope__options { display: flex; flex-direction: column; gap: var(--space-2); }
.scope__option { text-align: left; border: 1px solid var(--color-border); background: var(--color-surface); border-radius: var(--radius); padding: 12px 14px; font-size: var(--text-md); color: var(--color-text); cursor: pointer; min-height: 48px; }
.scope__option:hover, .scope__option:focus-visible { border-color: var(--color-primary); background: var(--color-primary-soft); outline: none; }
@media (max-width: 640px) {
  .scope { align-items: flex-end; padding: 0; }
  .scope__panel { width: 100%; border-radius: var(--radius-xl) var(--radius-xl) 0 0; padding-bottom: calc(var(--space-5) + env(safe-area-inset-bottom)); }
}
</style>
